/**
 * @group Components
 * @summary <blockquote>LineChartIcon icon component.</blockquote>
 * @example
 * ```tsx
 * <LineChartIcon />
 * ```
 */
export const LineChartIcon = ({ size = 16 }: { size?: number }) => (
        <svg
          height={size}
          strokeLinejoin="round"
          viewBox="0 0 16 16"
          width={size}
          style={{ color: 'currentcolor' }}
        >
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M1 1v11.75A2.25 2.25 0 0 0 3.25 15H15v-1.5H3.25a.75.75 0 0 1-.75-.75V1H1Zm13.297 5.013.513-.547-1.094-1.026-.513.547-3.22 3.434-2.276-2.275a1 1 0 0 0-1.414 0L4.22 8.22l-.53.53 1.06 1.06.53-.53L7 7.56l2.287 2.287a1 1 0 0 0 1.437-.023l3.573-3.811Z"
            clipRule="evenodd"
          />
        </svg>
      );